import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import Footer from '../../../Footer/FooterBottom';
import configData from '../../../Config/countries.json';
import { fetchRanks } from '../../actions';
import DashBoardBg from '../../../Admin/Question/View/Background/DashBoard/DashBoardBg';

import ProfileDetailsCard from './components/ProfileDetailsCard';
import PointsRanksSection from './components/PointsRanksSection';
import PointInfoModal from './components/PointInfoModal';
import './Profile.css';

const Profile = () => {
    const { t } = useTranslation('common');
    const dispatch = useDispatch();

    const user = useSelector(state => state.user);
    const ranks = useSelector(state => state.ranks);

    const [showPointInfo, setShowPointInfo] = useState(false);

    // Compute sorted countries list
    const countriesList = useMemo(() => {
        return (configData.countries || [])
            .slice()
            .sort((a, b) => (a.label > b.label ? 1 : -1))
            .map(item => ({
                value: item.value,
                name: item.label,
                label: (
                    <span className="d-inline-flex align-items-center">
                        <img
                            src={process.env.PUBLIC_URL + item.icon}
                            alt={item.label}
                            className="ml-1"
                            style={{ width: '18px', height: 'auto' }}
                        />
                        {item.label}
                    </span>
                )
            }));
    }, []);

    useEffect(() => {
        if (window.scrollToPosition) {
            window.scrollToPosition("main-dashboard-section");
        }
    }, []);

    useEffect(() => {
        if (user && user.user && user.user.UserType && user.user.UserType.Id !== 1) {
            dispatch(fetchRanks());
        }
    }, [user, dispatch]);

    if (!user) {
        return null;
    }

    const userData = (user && user.user) ? user.user : user;
    const countryObj = userData && userData.Country
        ? countriesList.find(p => p.value === userData.Country)
        : null;

    const rawName = userData ? `${userData.FirstName || ''} ${userData.SecondName || ''} ${userData.LastName || ''}`.trim() : '';
    const fullName = rawName.length > 0 ? rawName : (userData?.Name || userData?.FullName || userData?.Username || 'المستخدم');

    return (
        <>
            <PointInfoModal
                show={showPointInfo}
                onHide={() => setShowPointInfo(false)}
                t={t}
            />

            <section
                className="pos-rel padding-bottom padding-top pt-4 profile-dashboard-section"
                id="main-dashboard-section"
                style={{ minHeight: '100vh' }}
            >
                {/* Main background component preserved without modification */}
                <DashBoardBg user={user} />

                <Helmet>
                    <title>
                        {fullName} | {t('Pages.Profile.title')}
                    </title>
                </Helmet>

                <div className="container">
                    {/* User Profile Details Card & Actions */}
                    <ProfileDetailsCard
                        user={userData}
                        countryObj={countryObj}
                        t={t}
                    />

                    {/* Monthly Ranks & Points Grid Section */}
                    <PointsRanksSection
                        user={userData}
                        ranks={ranks}
                        onOpenInfoModal={() => setShowPointInfo(true)}
                        t={t}
                    />
                </div>
            </section>

            <div className="position-sticky">
                <Footer />
            </div>
        </>
    );
};

export default Profile;
